/* global femcare */

/**
 * Popup module for initializing popup functionality.
 */
femcare.popup = {
    popups: document.querySelectorAll('.modal--popup'),
    popUpCookieExpirationHours: 24,

    /**
     * Initializes the popup functionality.
     */
    init() {
        if (this.popups.length) {
            this.initPopups();
        }
    },

    /**
     * Initializes each popup based on their configured timers.
     */
    initPopups() {
        this.popups.forEach(popup => {
            const popupId = popup.getAttribute('id');
            const cookieName = `popup_dismissed_${popupId}`;

            // If cookie exists, skip showing this popup
            if (document.cookie.includes(`${cookieName}=true`)) {
                return;
            }

            const delay = parseInt(popup.getAttribute('data-popup-delay'), 10) || 0;

            setTimeout(() => {
                popup.classList.add('displayed');
                const focusableElements = popup.querySelectorAll(femcare.shared.util.focusableSelectors);
                if (focusableElements.length) {
                    focusableElements[0].focus();
                }
                femcare.modal.trapFocus(popup);
            }, delay * 1000);

            const closeBtn = popup.querySelector('.modal__close');
            closeBtn.addEventListener('click', () => {
                this.setPopupCookie(cookieName);
            });

            // Close popup and save cookie when clicking on the backdrop.
            popup.addEventListener('click', () => {
                this.setPopupCookie(cookieName);
            });
        });
    },

    /**
     * Sets a cookie to mark this popup as dismissed with expiration time.
     * @param {string} name - Name of the cookie.
     */
    setPopupCookie(name) {
        const date = new Date();
        const msPerHour = 60 * 60 * 1000;
        date.setTime(date.getTime() + (this.popUpCookieExpirationHours * msPerHour));
        document.cookie = `${name}=true; expires=${date.toUTCString()}; path=/`;
    }
};
